var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1484 5.79688L7.20312 0.851562C7.01562 0.664062 6.66406 0.5 6.40625 0.5H1.625C0.992188 0.5 0.5 1.01562 0.5 1.625V6.42969C0.5 6.6875 0.640625 7.03906 0.828125 7.22656L5.77344 12.1719C6.21875 12.6172 6.94531 12.6172 7.36719 12.1719L12.1484 7.39062C12.5938 6.96875 12.5938 6.24219 12.1484 5.79688ZM3.125 4.25C2.49219 4.25 2 3.75781 2 3.125C2 2.51562 2.49219 2 3.125 2C3.73438 2 4.25 2.51562 4.25 3.125C4.25 3.75781 3.73438 4.25 3.125 4.25ZM15.1484 7.39062C15.5938 6.96875 15.5938 6.24219 15.1484 5.79688L10.2031 0.851562C10.0156 0.664062 9.66406 0.5 9.40625 0.5H8.25781L12.8516 5.11719C13.25 5.51562 13.4844 6.03125 13.4844 6.59375C13.4844 7.15625 13.25 7.69531 12.8516 8.09375L8.77344 12.1719C9.21875 12.6172 9.94531 12.6172 10.3672 12.1719L15.1484 7.39062Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.9eb4b958.svg";
export { ForwardRef as ReactComponent };